module.exports = __webpack_public_path__ + "static/linkedin-logo-light-0f3718246ffcf74590d3331e5fe7830f.png";